import React from "react";
import { Button,  Form, Input, Typography } from "antd";
import { Link } from "react-router-dom";
import { useForgotPasswordContext } from "context/ForgotPasswordEnumeratorContext";

import { RoleTypes } from "enum/role-type-enum";
import { useEnumeratorPasswordOtpRequest } from "api/enumerator/ChangePassword/usePasswordOtpRequest";
import { useRecruiterPasswordOtpRequest } from "api/recruiter/ChangePassword/usePasswordOtpRequest";

const { Text, Title } = Typography;

interface PasswordOtpReuqestProps {
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  roleType: string | null;
}

const PasswordOtpReuqest: React.FC<PasswordOtpReuqestProps> = ({ setEmail, roleType }) => {
  const [form] = Form.useForm();

  const enumeratorPasswordRequestMutation = useEnumeratorPasswordOtpRequest();
  const recruiterPasswordRequestMutation = useRecruiterPasswordOtpRequest();

  const { setIsEmailSent, setIsFirstStep } = useForgotPasswordContext();

  const handleSubmit = async () => {
    const parameters = await form.validateFields();
    setEmail(parameters.emailOrPhone);

    if (roleType === RoleTypes.ENUMERATOR) {
      enumeratorPasswordRequestMutation.mutate(parameters, {
        onSuccess: () => {
          setIsEmailSent(true);
          setIsFirstStep(false);
        },
      });
    }

    if (roleType === RoleTypes.RECRUITER) {
      recruiterPasswordRequestMutation.mutate(parameters, {
        onSuccess: () => {
          setIsEmailSent(true);
          setIsFirstStep(false);
        },
      });
    }
  };

  return (
    <>
      <Title level={2}>Change Password ?</Title>
      <Text type="secondary">Please continue with your verified email address.</Text>
      <div className="mt-8">
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            name="emailOrPhone"
            label="Email Address"
            rules={[
              {
                required: true,
                message: "Email is required",
              },
              {
                type: "email",
                message: "Please enter valid email",
              },
            ]}
          >
            <Input placeholder="eg. example123@gmail.com" />
          </Form.Item>
          <Text type="secondary" style={{ fontSize: "13px" }}>
            We will send temporary code (OTP) in this email address.
          </Text>
          <Form.Item>
            <Button
              style={{ width: "100%", marginTop: "20px" }}
              htmlType="submit"
              loading={
                roleType === RoleTypes.ENUMERATOR
                  ? enumeratorPasswordRequestMutation.isPending
                  : recruiterPasswordRequestMutation.isPending
              }
              type="primary"
              className="h-12 px-8 border-2 border-border text-base  flex justify-center items-center gap-2 bg-primary text-white border-none w-full mt-12"
            >
              Continue
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="mt-5">
        <Text className="text-base">
          Remember your password ? <Link to={`/login?roleType=${roleType}`}>Click here.</Link>
        </Text>
      </div>
    </>
  );
};
export default PasswordOtpReuqest;
